import { useEffect, useMemo } from 'react';
import { useDispatch } from 'react-redux';

import { showAlert } from '../../../slice/AlertSlice';
import { Variants } from '@/types/common';
import { mapDropDownValues, useGetDropdownDataQuery } from './propertyApi';

export type DropdownOption = { value: string; label: string };

/**
 * RTK Query-backed replacement for the legacy `FetchDropDownData` hook.
 * Resolves the endpoint against `/property-service` or `/entity-service`
 * (both return a flat string[]), then maps to `{ value, label }[]`.
 * Errors surface through the existing AlertSlice channel, matching the
 * legacy hook's behavior.
 */
export function useDropdownOptions(
  endpoint: string,
  serviceType: 'property' | 'entity',
): DropdownOption[] {
  const dispatch = useDispatch();
  const { data, error } = useGetDropdownDataQuery({ endpoint, serviceType });

  useEffect(() => {
    if (error) {
      dispatch(showAlert({ type: Variants.ERROR, apiResponse: error }));
    }
  }, [error, dispatch]);

  return useMemo(() => mapDropDownValues(data ?? []), [data]);
}
